import SubmitInput from '@alltrails/denali/components/SubmitInput';
import ArrowRec from '@alltrails/denali/icons/ArrowRec';
import useAskResponse from '@/hooks/useAskResponse';
import styles from './AskSidebar.module.scss';

const characterLimit = 1000;

type Props = {
  onChange: (question: string) => void;
  onSubmit: (question: string) => void;
  value: string;
};

const AskInput = ({ onChange, onSubmit, value }: Props) => {
  const { isFetching } = useAskResponse();

  const placeholderText = 'Ask about trails'; // hwandrew TODO: XPLR-204 translations

  return (
    <SubmitInput
      characterLimit={characterLimit}
      className={styles.input}
      disabled={!value.trim() || isFetching}
      multiline
      onChange={onChange}
      onSubmit={() => {
        if (value.trim() && value.length <= characterLimit) {
          onSubmit(value);
        }
      }}
      placeholder={placeholderText}
      submitIcon={{ Component: ArrowRec }}
      submitOnEnter
      value={value}
    />
  );
};

export default AskInput;
